import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import { PanelFooter, PanelHeader } from 'components/Panel'

import { Offcanvas } from 'react-bootstrap'

function VerComite(props) {
	const { comite, setQueMostrar } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Ver comité" />
			<Offcanvas.Body>
				<h1>Datos del comité</h1>
				<Row>
					<Col sm={12} md={6}>
						<Table>
							<thead></thead>
							<tbody>
								<tr>
									<th>Id</th>
									<td>{comite.id}</td>
								</tr>
								<tr>
									<th>Nombre</th>
									<td>{comite.nombre}</td>
								</tr>
								<tr>
									<th>Texto</th>
									<td>{comite.texto}</td>
								</tr>
								<tr>
									<th>Orden</th>
									<td>{comite.orden || '-'}</td>
								</tr>
							</tbody>
						</Table>
					</Col>
					<Col sm={12} md={6} className="text-center">
						<h3>Foto</h3>
						<div className="logo-img">
							<img src={comite.multimedia ? process.env.REACT_APP_API_URL + 'uploads/' + comite.multimedia.url : 'logo192.jpg'} alt={comite.nombre}/>
						</div>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="primary" onClick={handleClose}>
					Ok
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default VerComite